import type { Ref } from 'react';
import { useHorizontalDragScroll } from '@/hooks/useHorizontalDragScroll';
import { cn } from '@/utils/cn';

interface SliderWrapperProps extends React.HTMLAttributes<HTMLDivElement> {
  ref?: Ref<HTMLDivElement>;
}

export const SliderWrapper = ({ className, children, ref, ...props }: SliderWrapperProps) => {
  const {
    setScrollRef,
    handlePointerDown,
    handlePointerMove,
    handlePointerUp,
    handlePointerCancel,
    handleClickCapture,
    handleDragStart,
  } = useHorizontalDragScroll();

  const handleRef = (node: HTMLDivElement | null) => {
    setScrollRef(node);

    if (typeof ref === 'function') {
      ref(node);
      return;
    }

    if (ref) {
      ref.current = node;
    }
  };

  return (
    <div
      ref={handleRef}
      style={{ WebkitOverflowScrolling: 'touch' }}
      onPointerDown={handlePointerDown}
      onPointerMove={handlePointerMove}
      onPointerUp={handlePointerUp}
      onPointerCancel={handlePointerCancel}
      onClickCapture={handleClickCapture}
      onDragStart={handleDragStart}
      className={cn('overflow-x-auto overflow-y-hidden hide-scrollbar cursor-grab active:cursor-grabbing select-none', className)}
      {...props}
    >
      {children}
    </div>
  );
};
